import { render, staticRenderFns } from "./Ordine.vue?vue&type=template&id=6d0efd01&scoped=true&"
import script from "./Ordine.vue?vue&type=script&lang=js&"
export * from "./Ordine.vue?vue&type=script&lang=js&"
import style0 from "./Ordine.vue?vue&type=style&index=0&id=6d0efd01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0efd01",
  null
  
)

export default component.exports